import wretch from 'wretch';
import * as v from 'valibot';
import { LanguageDataScheme, TLanguageData } from '../schemas/language';
import { localizedErrorHandlers } from '../localizedErrorHandlers';

export const getLanguage = async (
  baseUrl: string,
  bundle: string,
  locale: string,
): Promise<TLanguageData> => {
  const url = `${baseUrl}/text?name=translations&bundle=${bundle}&locale=${locale}`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(LanguageDataScheme, response);

    if (validatedResponse.success) {
      return validatedResponse.output;
    } else {
      console.error('fe-core | getLanguage | ', validatedResponse.issues);
      throw new Error('Invalid language data response');
    }
  });
};
